import type * as Types from './storefront-types';

import type { TypedDocumentNode as DocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
export const StorefrontNavigationSearchResultsFragmentDoc = gql`
    fragment StorefrontNavigationSearchResults on SearchResultItemConnection {
  edges {
    cursor
    node {
      ... on Page {
        title
        handle
      }
      ... on Product {
        title
        handle
      }
      ... on Article {
        title
        handle
        blog {
          handle
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<Types.StorefrontNavigationSearchResultsFragment, unknown>;
export const FetchStorefrontNavigationDocument = gql`
    query FetchStorefrontNavigation($first: Int!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  pages(first: $first, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  collections(first: $first, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  products(first: $first, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  articles(first: $first, sortKey: TITLE) {
    edges {
      node {
        title
        handle
        blog {
          handle
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationQuery, Types.FetchStorefrontNavigationQueryVariables>;
export const FetchStorefrontNavigationArticlesDocument = gql`
    query FetchStorefrontNavigationArticles($first: Int!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  articles(first: $first, after: $after, sortKey: TITLE) {
    edges {
      node {
        title
        handle
        blog {
          handle
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationArticlesQuery, Types.FetchStorefrontNavigationArticlesQueryVariables>;
export const FetchStorefrontNavigationCollectionsDocument = gql`
    query FetchStorefrontNavigationCollections($first: Int!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  collections(first: $first, after: $after, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationCollectionsQuery, Types.FetchStorefrontNavigationCollectionsQueryVariables>;
export const FetchStorefrontNavigationPagesDocument = gql`
    query FetchStorefrontNavigationPages($first: Int!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  pages(first: $first, after: $after, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationPagesQuery, Types.FetchStorefrontNavigationPagesQueryVariables>;
export const FetchStorefrontNavigationProductsDocument = gql`
    query FetchStorefrontNavigationProducts($first: Int!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  products(first: $first, after: $after, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationProductsQuery, Types.FetchStorefrontNavigationProductsQueryVariables>;
export const FetchStorefrontNavigationSearchDocument = gql`
    query FetchStorefrontNavigationSearch($query: String!, $first: Int!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  pages: search(query: $query, types: [PAGE], first: $first, prefix: LAST) {
    ...StorefrontNavigationSearchResults
  }
  products: search(query: $query, types: [PRODUCT], first: $first, prefix: LAST) {
    ...StorefrontNavigationSearchResults
  }
  articles: search(query: $query, types: [ARTICLE], first: $first, prefix: LAST) {
    ...StorefrontNavigationSearchResults
  }
  predictiveSearch(query: $query, types: [COLLECTION], limit: 10) {
    collections {
      title
      handle
    }
  }
}
    ${StorefrontNavigationSearchResultsFragmentDoc}` as unknown as DocumentNode<Types.FetchStorefrontNavigationSearchQuery, Types.FetchStorefrontNavigationSearchQueryVariables>;
export const FetchStorefrontNavigationSearchCollectionsDocument = gql`
    query FetchStorefrontNavigationSearchCollections($query: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  predictiveSearch(query: $query, types: [COLLECTION], limit: 10) {
    collections {
      title
      handle
    }
  }
}
    ` as unknown as DocumentNode<Types.FetchStorefrontNavigationSearchCollectionsQuery, Types.FetchStorefrontNavigationSearchCollectionsQueryVariables>;
export const FetchStorefrontNavigationSearchGroupDocument = gql`
    query FetchStorefrontNavigationSearchGroup($query: String!, $types: [SearchType!]!, $first: Int!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  search(query: $query, types: $types, first: $first, after: $after, prefix: LAST) {
    ...StorefrontNavigationSearchResults
  }
}
    ${StorefrontNavigationSearchResultsFragmentDoc}` as unknown as DocumentNode<Types.FetchStorefrontNavigationSearchGroupQuery, Types.FetchStorefrontNavigationSearchGroupQueryVariables>;